import Vue from "vue";

const eventHandler = new Vue();

export default eventHandler;